//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationInputItem } from './TelephoneInformationInputItem';

export class TestParentInputItem extends ItemBase {
    FirstName: string | null = null;
    LastName: string | null = null;
    EmailAddress: string | null = null;
    Address: string | null = null;
    Note: string | null = null;
    TelephoneHome: TelephoneInformationInputItem | null = null;
    TelephoneMobile: TelephoneInformationInputItem | null = null;
    TelephoneWork: TelephoneInformationInputItem | null = null;

    constructor(initializer?: Partial<TestParentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestParentInputItem";
}
